module.exports = __webpack_public_path__ + "assets/5e2d7ff1b1f15ad7467000a37459aced.mp4";